<template>
  <div class="servizi-bottom" :class="{ 'dettaglio-espanso': showDettaglio, 'fatture': fatture, 'multi-azienda': multiAzienda }">
    <hr v-if="!showDettaglio"/>
    <h3 class="servizi-info-center">Stato servizi: {{postazione}}</h3>
    <led v-for="(stato, idx) in statoServizi" :key="idx" :status="stato"/>
    <div class="servizi-dettaglio" @click="onDettaglio">{{ showDettaglio ? 'Chiudi dettaglio' : 'Dettaglio' }}</div>
    <div v-if="showDettaglio" style="clear:both;">
      <dettaglio v-for="(stato, idx) in statoServizi" :key="stato.modulo" :status="stato" :header="idx === 0"/>
    </div>
    <div v-if="showDettaglio" class="accesso-multiplo" style="clear:both;">
      <van-button v-for="(m, idx) in multipli" :key="idx" plain small type="primary" style="margin-right: 10px;" @click="onMultiplo(m)">{{ m.descrizione }}</van-button>
    </div>
  </div>
</template>

<script>
import configurazioni from '@/services/configurazioniService.js'
import Led from './led.vue'
import Dettaglio from './dettaglio.vue'
import { insomnia } from '@/mixins/insomnia.js'

export default {
  components: {
    Led,
    Dettaglio
  },
  mixins: [
    insomnia
  ],
  props: {
    fatture: Boolean,
    multiAzienda: Boolean
  },
  data() {
    return {
      showDettaglio: false,
      multipli: []
      // multipli: [{ codice: 'multiplo_01_base', descrizione: 'ubico_test01' }, { codice: 'multiplo_02_base', descrizione: 'hpierre_centersport01' }]
    }
  },
  async mounted() {
    this.multipli = await configurazioni.getMultipli()
  },
  computed: {
    statoServizi() {
      return this.$store.getters.serviceStatus
    },
    postazione() {
      return configurazioni.getPostazione()
    }
  },
  methods: {
    onDettaglio() {
      this.showDettaglio = !this.showDettaglio
      this.$emit('dettaglio', this.showDettaglio)
    },
    async onMultiplo(m) {
      await this.cicleSyncProcess(m)
    }
  }
}
</script>

<style lang="scss">
  .servizi-bottom {
    bottom: 0;
    position: absolute;
    width: 100%;
    min-height: 150px;
    &.fatture {
      bottom: 19vh;
      &.multi-azienda {
        bottom: 19vh;
      }
    }
  }

  .dettaglio-espanso {
    height: 100%;
    &.multi-azienda {
      height: 56vh;
    }
    &.fatture {
      height: 62vh;
      &.multi-azienda {
        height: 56vh;
      }
    }
  }

  .servizi-info-center {
    text-align: center;
    width: 100%;
  }

  .servizi-dettaglio  {
    bottom: 9px;
    position: absolute;
    right: 12px;
    text-decoration: underline;
    cursor: pointer;
  }

  .accesso-multiplo {
    bottom: 9px;
    position: absolute;
    left: 12px;
  }
</style>
